import React from 'react';  
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Image from 'react-bootstrap/Image'
import Row from 'react-bootstrap/Row'
import Badge from 'react-bootstrap/Badge'



function Help(props) {  

	return (  
		<>
			<h1 className="text-center">Web Logger Help</h1>
			<Row style={{ marginLeft: '15px' }}>
				This is the help page/user manual for the Dekimo Web Logger. This web application allows a Dekimo employee to log his effort.
				Once the employee has logged into the web logger, a menu is available with the necessary functions to register the effort.
			</Row>
			<br />
			<br />
			<Accordion>
				<Card>
					<Accordion.Toggle as={Card.Header} eventKey="1">
						<h2>Menu</h2>
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="1">
						<Card.Body>
							<Row>
								<Image src="menu.png" rounded />
							</Row>
							Through the menu, functionalities like log and generation of reports can be accessed.
							<br />
							<br />
							<Accordion>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="11">
										<h3>Log</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="11">
										<Card.Body>
											<Row>
												<Image src="log.png"  rounded/>
											</Row>
											This is the main functionality of the web logger. It is accessed automatically when logging into the web logger.
											This allows the user to add one or more logs at the same time.
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="12">
										<h3>Reports</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="12">
										<Card.Body>
											<Row>
												<Image src="report.png" rounded />
											</Row>
											The reports menu provides a number of reports that can be generated on the fly for the selected period.
											<br />
											<br />

											<Accordion>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="121">
														<h4>Holiday Report</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="121">
														<Card.Body>
															This report generates an overview of the holidays (personal as well as official).
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="122">
														<h4>Distance Report</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="122">
														<Card.Body>
															This report generates an overview of the job related distances travelled that should be refunded.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="123">
														<h4>Log Report</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="123">
														<Card.Body>
															This report generates an overview of the efforts done for the selected period.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="124">
														<h4>Timesheet</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="124">
														<Card.Body>
															This timesheet generates an document which contains the effort done that can be sent to the customer for approval.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="125">
														<h4>Summary Report</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="125">
														<Card.Body>
															This summary report generates a document which contains the summary of hours of work, illness and holidays taken for the selected period. If no report is available, contact your HR division for support. 
														</Card.Body>
													</Accordion.Collapse>
												</Card>
											</Accordion>
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="14">
										<h3>Log out</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="14">
										<Card.Body>
											Log out of the web logger. This is to be advised when you use a public PC to log your efforts.
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="13">
										<h3>Help</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="13">
										<Card.Body>
											This is this page.
										</Card.Body>
									</Accordion.Collapse>
								</Card>
							</Accordion>					
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card>
					<Accordion.Toggle as={Card.Header} eventKey="4">
						<h2>Calendar legend</h2>
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="4">
						<Card.Body>
							<Row>
								Every day in the calendar has a colour depending on the logs belonging to that day.
							</Row>	
							<Row style={{  padding: '5px' }}>
								<Badge variant={"success"} >{7}</Badge>&nbsp; Logs for this day are present(OK). 
							</Row>
							<Row style={{ padding: '5px' }}>
								<Badge variant={"warning"} >{7}</Badge>&nbsp; Not enough logs registered for this day.
							</Row>
							<Row style={{ padding: '5px' }}>
								<Badge variant={"danger"} >{7}</Badge>&nbsp; No logs registered for this day.
							</Row>
							<Row style={{ padding: '5px' }}>
								<Badge variant={"primary"} >{7}</Badge>&nbsp; Overtime logs registered for this day.
							</Row>
							<br />
							<br />
							<Row>
								Besides the daycolour, extra small coloured dots may be added.
							</Row>	
							<Row style={{ padding: '5px' }}>
								<div>
									<Badge variant={"success"} >{7}</Badge>
									<span style={{ position: "absolute" }}>
										<sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={"warning"}>&nbsp;</Badge></sup></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
									</span>
								</div>
								&nbsp;&nbsp;&nbsp;&nbsp;Absence by holiday
							</Row>	
							<Row style={{ padding: '5px' }}>
								<div>
									<Badge variant={"success"} >{7}</Badge>
									<span style={{ position: "absolute" }}>
										<sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sup></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={"danger"}>&nbsp;</Badge></sub></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
									</span>
									&nbsp;&nbsp;&nbsp;&nbsp;Absence by illness
								</div>
							</Row>	
							<Row style={{ padding: '5px' }}>
								<div>
									<Badge variant={"success"} >{7}</Badge>
									<span style={{ position: "absolute" }}>
										<sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={"secondary"}>&nbsp;</Badge></sup></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
									</span>
									&nbsp;&nbsp;&nbsp;&nbsp;Absence by illness or holiday (because the projecttask for illness or holidays is hosted by the same project)
								</div>
							</Row>	
							<Row style={{ padding: '5px' }}>
								<div>
									<Badge variant={"success"} >{7}</Badge>
									<span style={{ position: "absolute" }}>
										<sub><sup style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sup></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={undefined}>&nbsp;</Badge></sub></sub>
										<sub><sub style={{ position: "relative", display: "block", left: "1px", top: "-5px" }}><Badge pill variant={"primary"}>&nbsp;</Badge></sub></sub>
									</span>
								</div>
								&nbsp;&nbsp;&nbsp;&nbsp;Distance travelled to be refunded
							</Row>	
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card>
					<Accordion.Toggle as={Card.Header} eventKey="2">
						<h2>Logging an effort</h2>
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="2">
						<Card.Body>
							<Row>
								<Image src="log.png" rounded />
							</Row>
							Once logged into the web logger, manually or automatically, the log page is shown.
							The log page can always be visited by selecting "Log" from the menu.
							<br />
							<br />
							<Accordion>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="21">
										<h3>Selecting the date(range)</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="21">
										<Card.Body>
											The first thing you need to do is to select a single date or select a daterange, for which the effort will be logged on.
											Default, today will be selected as the current date.
											The selected date or daterange is shown in green. This selection can be changed by clicking on the start and end date.
											Depending on which day was already selected, a new start or enddate will be shown.
											It takes some time to get used to this way of selecting a daterange.
											If only a single date is required, one can double-click the required date.
											<Row>
												<Image src="singledate.png" rounded />
											</Row>
											<Row>
												<Image src="daterange.png" rounded />
											</Row>
											Below the calendar is a list of logs that will reflect the selected date(range).
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="22">
										<h3>Date preselections</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="22">
										<Card.Body>
											<Row>
												<Image src="datepreselections.png" rounded />
											</Row>
											There are some predefined daterange selections foreseen, accessible through the icons right below the calendar.
											You can hover the icons to see which daterange they will select.
											The possible selections are: Previous week, this week, previous month and this month.
											These come in handy when you log your efforts only once a week or once a month.
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="23">
										<h3>Add the log</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="23">
										<Card.Body>
											<Row>
												<Image src="addlog.png" rounded />
											</Row>
											Below the calendar and its quick period selection buttons, a list of registered logs for the selected date(range) is shown. 
											At the end of that list, an empty log will be present with a button to add a new log or multiple logs if a period is selected instead of a single day.
											Clicking that button will show a form to enter the details of the log to be added.
											<Row>
												<Image src="logdetails.png" rounded />
											</Row>
											<br />
											<br />
											<Accordion>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="231">
														<h4>Project</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="231">
														<Card.Body>
															Select the appropriate project from the list. The list contains 3 sublists. The upper sublist is a list of
															projects recently used to log effort on.
															The second list of projects contains projects used by the company recently to log effort on. 
															The last sublist is a complete list of all active projects.
															The known effort already spent on the project is shown in the badge next to the project.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="232">
														<h4>Project task</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="232">
														<Card.Body>
															Select the appropriate project task from the list. If no appropriate task is availlable, contact the projectleader of the project.
															The known effort already spent on the project task is shown in the badge next to the project task.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="233">
														<h4>Duration</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="233">
														<Card.Body>
															Enter the duration of the effort for the selected project task. This is entered in either days or hours, depending on the project definition.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="234">
														<h4>Location & distance</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="234">
														<Card.Body>
															In case there are kilometers travelled by car involved for the effort that should be refunded, one should enter the location and kilometers travelled.
															Some projects do not support these fields. E.g. Holiday and Absence projects.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="235">
														<h4>Description</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="235">
														<Card.Body>
															If you are working in a Projects/Development division (as opposed to a Consultancy/Experts division), it is strongly advised to always add a description of the effort spent. 
															The reason is that the effort is typically spent in our own Dekimo offices (without customer presence), and a good description will avoid discussions when the customer is billed for the effort. 
															If you are working in a Consultancy/Experts division, it is not customary nor necessary to put a description, as the work is typically agreed in general and you are working at the customer location.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
												<Card>
													<Accordion.Toggle as={Card.Header} eventKey="236">
														<h4>Cancel, paste or save the log</h4>
													</Accordion.Toggle>
													<Accordion.Collapse eventKey="236">
														<Card.Body>
															<Row>
																<Image src="savelog.png" rounded/>
															</Row>
															At the bottom of the form, you can submit the log, discard the log or paste the log(which was copied earlier). 
															The freshly added log is visible immediately in the list and the calendar is updated.
														</Card.Body>
													</Accordion.Collapse>
												</Card>
											</Accordion>
										</Card.Body>
									</Accordion.Collapse>
								</Card>
								<Card>
									<Accordion.Toggle as={Card.Header} eventKey="24">
										<h3>Delete, copy or edit a log</h3>
									</Accordion.Toggle>
									<Accordion.Collapse eventKey="24">
										<Card.Body>
											<Row>
												<Image src="modifylog.png" rounded />
											</Row>
											Selecting an existing log from the list, will show some actions buttons. With these buttons, one can delete the log, copy the log or edit the current log.
										</Card.Body>
									</Accordion.Collapse>
								</Card>
							</Accordion>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card>
					<Accordion.Toggle as={Card.Header} eventKey="3">
						<h2>Generating reports</h2>
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="3">
						<Card.Body>
							Several kinds of reports can be generated. See Menu/Reports.
							Select the appropriate type of report from the menu.
							Select the period for which the report should be generated.
							Press the generate button <Image src="note.png" rounded width="64px"/>. A new window will be openend with the requested report.
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
		</>
      );  
    
}  

export default Help  
